import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonAlignCenter
  from 'components/atoms/Editors/EditorMenuButtonAlignCenter/EditorMenuButtonAlignCenter.styles';

const EditorMenuButtonAlignCenter = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonAlignCenter');

  return <StyledEditorMenuButtonAlignCenter buttonRef={ref} {...innerProps} />
});

EditorMenuButtonAlignCenter.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonAlignCenter;
